import { Model } from "infrontjs";

export class Pack extends Model
{
    static schema = {
        id: { type: 'string', default: null },
        organisationId: { type: 'string', default: null },
        userId: { type: 'string', default: null },
        status: { type: 'string', enum: ['ACTIVE', 'INACTIVE'], default: 'INACTIVE' },
        name: { type: 'string', default: null },
        description: { type: 'string', default: null },
        templateIds: { type: 'array', default: [] },
        data: { type: 'object', default: null },
        createdAt: { type: 'datetime', default: null },
        updatedAt: { type: 'datetime', default: null }
    };
}
